// Import model
import { StartLeadAppointmentCancelAppointmentRequest } from '../models/StartLeadAppointmentCancelAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadAppointmentCancelAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadAppointmentCancelAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadAppointmentCancelAppointmentRequest instance
   */
  static deserialize(json: string): StartLeadAppointmentCancelAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadAppointmentCancelAppointmentRequest instance
   */
  static fromObject(obj: any): StartLeadAppointmentCancelAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadAppointmentCancelAppointmentRequest');
    }


    const instance: StartLeadAppointmentCancelAppointmentRequest = {
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadAppointmentCancelAppointmentRequest instances
   */
  static deserializeArray(json: string): StartLeadAppointmentCancelAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadAppointmentCancelAppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartLeadAppointmentCancelAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadAppointmentCancelAppointmentRequest instance to a plain object
   */
  static toObject(instance: StartLeadAppointmentCancelAppointmentRequest): any {
    return {
    };
  }

  /**
   * Serializes an array of StartLeadAppointmentCancelAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadAppointmentCancelAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
